import React from 'react'

import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

interface Props {
    addTodo: (e: React.FormEvent<HTMLFormElement>) => void
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    inputValue: string
}

const AddTodo = ({inputValue, handleInputChange, addTodo}: Props) => {
    const {t} = useTranslation()
    return (
        <form
            className={clsx('add-todo', {active: inputValue})}
            onSubmit={addTodo}
        >
            <label className="add-todo-icon icon" htmlFor="add-todo-input"></label>
            <div className="add-todo-input">
                <input
                    id="add-todo-input"
                    type="text"
                    placeholder={t('new_task')}
                    value={inputValue}
                    onChange={handleInputChange}
                />
            </div>
            <div className="add-todo-action">
                <button className="btn-reset btn-add" type="submit">
                    {t('save_short')}
                </button>
            </div>
        </form>
    )
}

export default AddTodo

/*

*/
